const MIDI_SERVICE_UID            = '03B80E5A-EDE8-4B33-A751-6CE34EC4C700'.toLowerCase();
const MIDI_IO_CHARACTERISTIC_UID  = '7772E5DB-3868-4112-A1A9-F2669D106BF3'.toLowerCase();

export default class WebBleMidiTransmitter{
    bluetoothDevice;
    bleDeviceName;
    
    readyBLEpacket = [];
    bleSendTimer = null;
    sendInterval = 10;
    disconnectedCallback = null;

    lastsendTime = 0;

    /** Function for connecting to MIDIBLE Device */
    connect = async() => {
        console.log('Searching for bluetooth devices...');
        this.bluetoothDevice = null;
        // console.log('Searching for ' + getUrlVars()["demo"] + getUrlVars()["id"] + "...");
        try {
            let device = await window.navigator.bluetooth.requestDevice({
                filters: [{
                services: [MIDI_SERVICE_UID],
                name: this.bleDeviceName
                }]
            })
            
            console.log('Connecting to GATT server of ' + device.name);
            this.bluetoothDevice = device;
            let server = await device.gatt.connect();
        
            console.log('Getting Service...');
            let service = await server.getPrimaryService(MIDI_SERVICE_UID);
        
            console.log('Getting Characteristic...');
            let characteristic = await service.getCharacteristic(MIDI_IO_CHARACTERISTIC_UID);
        
            console.log('Found Characteristic...');
            this.onBleConnected();
            this.midiCharacteristics = characteristic;
            //this.bleSendTimer = setInterval(this.bleSend, this.sendInterval);

            return true;
            
        } catch (error) {
            console.log('Argh! ' + error);
            // alert('Argh! ' + error)
            //this.setState({errorMessage: "Failed to connect using Bluetooth."})
            return false;
        }
    };

    disconnect = () => {
        if (!this.bluetoothDevice) {
            return;
        }
        console.log('Disconnecting from Bluetooth Device...');

        clearInterval(this.bleSendTimer);
        this.bleSendTimer = null;
        
        if (this.bluetoothDevice.gatt.connected) {
            this.bluetoothDevice.gatt.disconnect();
            this.onBleDisconnected();
        } else {
            console.log('> Bluetooth Device is already disconnected');
        }
    };

    
    onDisconnected = (event) => {
        let device = event.target;

        console.log('Device ' + device.name + ' is disconnected.');

        this.onBleDisconnected();
    };

    
    midiEncoder = (midiData) => {
        let midiBLEmessage = [];
        let pos = 0;
        let len = midiData.length;

        //console.log('Encoding: ', midiData, performance.now());
        

        midiBLEmessage.push(this.timestampGenerator(performance.now() + midiData[0].time)[0]);
        for (const message of midiData) {
            //console.log(message.time, performance.now())
            if(message.time < performance.now()){
                for (pos = 0; pos < len;pos++) {
                    if ((message.message[pos] >>> 7) === 1) {
                        midiBLEmessage.push(this.timestampGenerator(performance.now() + message.time)[1]);
                    }
                    midiBLEmessage.push(message.message[pos]);
                }
                
            }
            else{
                break;
            }
        }
        

        //console.log('Encoded: ', midiBLEmessage);
        return midiBLEmessage;
    };

    getBlePackets = (interval) => {
        let currentTime = performance.now();

        // if(!this.beginSend){
        //     if(this.readyBLEpacket.length > 0 && this.readyBLEpacket[0].time < currentTime - 20){ // 
        //         let midiBLEmessage = [];
        //         midiBLEmessage.push(this.timestampGenerator(this.readyBLEpacket[0].time - 100, 0));
        //          midiBLEmessage.push(this.timestampGenerator(this.readyBLEpacket[0].time - 100, 1));
        //         this.beginSend = true;
        //         console.log(midiBLEmessage);
        //         return midiBLEmessage;
        //     }
        // }
        //console.log('getBlePackets: ',  interval); //this.readyBLEpacket, performance.now());
        //console.log('getBlePackets: ',  interval, currentTime); //this.readyBLEpacket, performance.now());
        // if(this.readyBLEpacket.length > 0){
        //     console.log(this.readyBLEpacket[0].time)
        // }
        
        if(this.readyBLEpacket.length > 0 && this.readyBLEpacket[0].time < currentTime - 10){ // 
          
            let midiBLEmessage = [];
            let initialTime = this.readyBLEpacket[0].time;
            midiBLEmessage.push(this.timestampGenerator(this.readyBLEpacket[0].time, 0));
            //console.log('Encoding: ', initialTime, this.readyBLEpacket);

            let index = 0;

            while (index < this.readyBLEpacket.length && this.readyBLEpacket[index].time < currentTime) { //   && this.readyBLEpacket[0].time < initialTime + 8000
                let message = this.readyBLEpacket[index];
                index++
               //console.log(message);
                for (var data of message.message) {
                    if ((data >>> 7) === 1) {
                        midiBLEmessage.push(this.timestampGenerator(message.time, 1));
                    }
                    midiBLEmessage.push(data);
                }
            }

            this.readyBLEpacket.splice(0, index)
            //console.log('Encoded: ', midiBLEmessage);
            this.lastsendTime = currentTime;
            return midiBLEmessage;
        }

        // //console.log(this.readyBLEpacket.length, this.readyBLEpacket[0]?.time, currentTime, currentTime - this.lastsendTime)
        // if((this.readyBLEpacket.length === 0 || this.readyBLEpacket[0].time > currentTime + 10) && currentTime - this.lastsendTime >= 10 ){ // 
        //     let midiBLEmessage = [];
        //     //midiBLEmessage.push(this.timestampGenerator(currentTime - 10, 0));
        //     //midiBLEmessage.push(this.timestampGenerator(currentTime - 10, 1));
        //     console.log(midiBLEmessage);
        //     this.lastsendTime = currentTime;
        //     return midiBLEmessage;
        // }
        
       
    };

    timestampGenerator = (delay, index) => {
        let localTime       = (delay) & 8191;
       // console.log(delay, localTime)
       if(index === 0){
            return ((localTime >> 7) | 0x80) & 0xBF;
       }
       else{
            return (localTime & 0x7F) | 0x80;
       }

    }

    onBleConnected = () =>  {
        console.log('bleConnected');
    }

    onBleDisconnected = () =>  {
        console.log('bleDisconnect');
        if(this.disconnectedCallback){
            this.disconnectedCallback();
        }
    }

    bleSend = (interval) => {
        if(!this.midiCharacteristics){
            return;
        }
        //if(this.readyBLEpacket.length > 0) {
        var sentOne = false;
        while (true) {
            let send = this.getBlePackets(interval);
            if(send){
                let packet = new Uint8Array(send);
                //console.log('BLE-packet sent: ', packet);
                this.midiCharacteristics.writeValueWithoutResponse(packet);
                sentOne = true;
                break;
            }
            else{
                break;
            }
        }
        

        

      
        // if(interval > this.sendInterval * 2){
        //     console.log("time: ", window.performance.now() - this.lastsendTime);
        //     if(!sentOne){
        //         this.midiCharacteristics.writeValueWithoutResponse(new Uint8Array());
        //     }
        //     this.lastsendTime = window.performance.now() ;
        // }
       
        
        //     this.readyBLEpacket = [];
    }

    sendMidiMessage = (uint8Array, delay) => {
        let midiMessage = uint8Array;
        //let l = midiMessage.length; 
       // console.log('MIDI-message: ' + midiMessage);

         this.readyBLEpacket.push({ 
            message: midiMessage,
            time: delay,
        });

        // for (let i = 0; i < l; i++) {
           
        // }
    }

    readPPCPValue(characteristic) {
            return characteristic.readValue().then(value => {
                alert('> Peripheral Preferred Connection Parameters: ');
                alert('  > Minimum Connection Interval: ' +
                    (value.getUint8(0) | value.getUint8(1) << 8) * 1.25 + 'ms');
                alert('  > Maximum Connection Interval: ' +
                    (value.getUint8(2) | value.getUint8(3) << 8) * 1.25 + 'ms');
                alert('  > Latency: ' +
                    (value.getUint8(4) | value.getUint8(5) << 8) + 'ms');
                alert('  > Connection Supervision Timeout Multiplier: ' +
                    (value.getUint8(6) | value.getUint8(7) << 8));
            }
        )
    }

    setDisconnectedCallback = (callback) =>{
        this.disconnectedCallback = callback
    }
};